import { CaseStatus, NotificationStatus } from '../types/enums';

interface StatusMapper<T> {
    map(status: string): T;
}

class CaseStatusMapper implements StatusMapper<CaseStatus> {
    private readonly statusMap: Record<string, CaseStatus> = {
        'PENDING': CaseStatus.PENDING,
        'ON_HOLD': CaseStatus.ON_HOLD,
        'IN_ANALYSIS': CaseStatus.IN_ANALYSIS,
        'NOT_APPLICABLE': CaseStatus.NOT_APPLICABLE,
        'SENDING_ERROR': CaseStatus.SENDING_ERROR,
        'NOTIFIED': CaseStatus.NOTIFIED,
        'TO_NOTIFY': CaseStatus.TO_NOTIFY
    };

    private readonly enumValues = new Set(Object.values(CaseStatus));

    map(status: string): CaseStatus {
        if (this.enumValues.has(status as CaseStatus)) {
            return status as CaseStatus;
        }

        const mapped = this.statusMap[status];
        if (!mapped) {
            console.warn(`Unknown status: ${status}`);
            throw new Error(`Unknown status: ${status}`);
        }
        return mapped;
    }
}

class NotificationStatusMapper implements StatusMapper<NotificationStatus> {
    private readonly statusMap: Record<string, NotificationStatus> = {
        'ON_TIME': NotificationStatus.ON_TIME,
        'AT_RISK': NotificationStatus.AT_RISK,
        'LATE': NotificationStatus.LATE
    };

    map(status: string): NotificationStatus {
        const mapped = this.statusMap[status];
        return mapped;
    }
}

export const caseStatusMapper = new CaseStatusMapper();
export const notificationStatusMapper = new NotificationStatusMapper();

